<!-- ***************************************************************************************************************************** -->
<!-- Form Div for Courses Explorer/Prerequisites -->
<tool-form formTitle="Prerequisite Filter">
  <form
    [formGroup]="prerequisitesForm"
    (ngSubmit)="prerequisitesSubmit()"
    class="form-content"
  >
    <!-- Course Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Enter a Course Number</mat-label>
      <input
        type="text"
        placeholder="MAC2311"
        matInput
        formControlName="course"
        [matAutocomplete]="auto"
        required
      />
      <button
        *ngIf="prerequisitesForm.value.course"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="prerequisitesForm.setValue({ course: '' })"
      >
        <i class="fas fa-times-circle"></i>
      </button>
      <mat-error
        *ngIf="prerequisitesForm.controls['course'].errors?.['required']"
      >
        You must select a course
      </mat-error>
      <mat-error
        *ngIf="prerequisitesForm.controls['course'].errors?.['not_found']"
      >
        Course not found
      </mat-error>

      <mat-autocomplete #auto="matAutocomplete">
        <cdk-virtual-scroll-viewport
          class="autocomplete-test-viewport"
          [ngStyle]="{ height: height }"
          itemSize="25"
        >
          <mat-option
            *cdkVirtualFor="let course of filteredCourses"
            [value]="course"
            class="autocomplete-item"
          >
            {{ course }}
          </mat-option>
        </cdk-virtual-scroll-viewport>
      </mat-autocomplete>
    </mat-form-field>

    <tool-form-action-button
      text="Submit"
      [disabled]="!prerequisitesForm.valid"
      (onClick)="closeDialog()"
    ></tool-form-action-button>
  </form>
</tool-form>
